import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Clock, Trophy, ChartLineUp } from "@phosphor-icons/react";
import { toast } from "sonner";

function fmt(secs) {
  const s = Math.max(0, parseInt(secs || 0, 10));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h}h ${m}m`;
}

export default function MyUsageCard() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/usage/me").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggleOpt = async (v) => {
    setSaving(true);
    try {
      await api.patch("/usage/me/leaderboard", { opt_in: !!v });
      setData((d) => ({ ...d, leaderboard_opt_in: !!v }));
      toast.success(v ? "Ya apareces en el ranking público" : "Ya no apareces en el ranking");
    } catch { toast.error("Error al actualizar"); }
    finally { setSaving(false); }
  };

  if (!data) return null;
  return (
    <div className="card-tactical p-6" data-testid="my-usage-card">
      <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#CCFF00] mb-1 flex items-center gap-1.5">
        <ChartLineUp size={12} weight="fill" /> Mi tiempo en la plataforma
      </p>
      <h3 className="font-['Barlow_Condensed'] text-2xl font-bold uppercase tracking-tight">Constancia</h3>
      <p className="text-xs text-gray-500 mt-1 mb-4">Solo tú ves estas cifras. Solo apareces en el ranking si activas la opción.</p>

      <div className="grid grid-cols-3 gap-2">
        <MiniBucket icon={Clock} label="Hoy" value={fmt(data.today?.seconds)} days={data.today?.days} />
        <MiniBucket icon={Clock} label="Esta semana" value={fmt(data.week?.seconds)} days={data.week?.days} />
        <MiniBucket icon={Clock} label="Este mes" value={fmt(data.month?.seconds)} days={data.month?.days} />
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-white/10">
        <div className="flex items-start gap-2">
          <Trophy size={16} className="text-[#FFD24A] mt-0.5" weight="fill" />
          <div>
            <Label className="text-xs text-white font-bold">Ranking público</Label>
            <p className="text-[10px] text-gray-500">Aparecer entre los usuarios más activos.</p>
          </div>
        </div>
        <Switch
          checked={!!data.leaderboard_opt_in}
          onCheckedChange={toggleOpt}
          disabled={saving}
          data-testid="my-usage-leaderboard-switch"
        />
      </div>
    </div>
  );
}

function MiniBucket({ icon: Icon, label, value, days }) {
  return (
    <div className="bg-black/40 border border-white/10 p-2.5 rounded">
      <p className="text-[9px] uppercase tracking-widest text-gray-500 font-bold flex items-center gap-1"><Icon size={10} /> {label}</p>
      <p className="text-lg font-['Barlow_Condensed'] font-black text-[#CCFF00] leading-none mt-1">{value}</p>
      <p className="text-[9px] text-gray-500 mt-0.5">{days ?? 0} día{days === 1 ? "" : "s"}</p>
    </div>
  );
}
